var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"NotFound text-center"},[_c('van-icon',{attrs:{"name":"warning-o","color":"#ff976a","size":"2.5rem"}}),_c('div',{staticClass:"padding5"},[_vm._v("您访问的页面不存在或暂时不可用，请检查网址后重试。")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }